export class CompanyLogoConfiguration {
    id: number;
    image: string;
    name: string;
    logoKey: string;
    collegeId: number;
    imageData: any
    imagePathUrl: string;
  }
